import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDictionary } from "@adamlip/okeoke.client";
import { Buffer } from "buffer";
import GeneralBackref from "./GeneralBackref";

const STATUSES = {
  FAIL: "app_simple_failedPayment",
  FAILED: "app_simple_failedPayment",
  CANCEL: "app_simple_cancelPayment",
  CANCELLED: "app_simple_cancelPayment",
  TIMEOUT: "app_simple_timeOut",
  NOT_FOUND: "app_simple_timeOut",
  CARD_NOTAUTHORIZED: "app_simple_failedPayment",
};

function SimplePayBackref() {
  // eslint-disable-next-line
  const [searchParams] = useSearchParams();
  const [decodedParams, setDecodedParams] = useState(null);
  const { getValue } = useDictionary();

  const [orderUUID, setOrderUUID] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoaded(true);
    }, 6000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    let stringToDecode = searchParams.get("r");
    let decoded = JSON.parse(Buffer.from(stringToDecode, "base64").toString());
    setDecodedParams(decoded);
    let splitRef = decoded.o.split("-");
    let uuid = splitRef.length > 1 ? splitRef[2] : splitRef[0];
    setOrderUUID(uuid);
    // eslint-disable-next-line
  }, []);

  return (
    <GeneralBackref
      loading={!loaded || decodedParams == null}
      success={decodedParams?.e === "SUCCESS"}
      transactionID={decodedParams?.t}
      errorMessage={
        STATUSES?.[decodedParams?.e] != null
          ? getValue(STATUSES?.[decodedParams?.e])
          : null
      }
      orderUUID={orderUUID}
      paymentAgent={"SimplePay"}
    />
  );
}

export default SimplePayBackref;
